import React from "react";
import Heading from "../../common/Heading";
import { Container, ExperienceBox } from "../experience/experience_element";
import ExperienceTile from "./ExperienceTile";
import { experienceSection } from "../../data";

const Experience = () => {
  return (
    <Container id="experience">
      <Heading heading="Experiences" subheading="" />
      <ExperienceBox>
        {experienceSection.map((experience, i) => {
          return (
            <ExperienceTile
              key={i}
              index={i}
              title={experience.title}
              subtitle={experience.description}
              desc={experience.year}
              img={experience.icon}
            />
          );
        })}
      </ExperienceBox>
    </Container>
  );
};

export default Experience;
